'use strict';

module.exports = {
    init: function () {
        //var featureDetect = require('./featureDetect');

        var lazySizesConfig = window.lazySizesConfig = window.lazySizesConfig || {};
        lazySizesConfig.init = false;
        lazySizesConfig.loadMode = 2;
        lazySizesConfig.preloadAfterLoad = false;
        lazySizesConfig.ricTimeout = 250;
        lazySizesConfig.expand = 700;
        lazySizesConfig.loadHidden = false;
        lazySizesConfig.srcAttr = 'data-lazy';
        lazySizesConfig.srcsetAttr = 'data-srcset';
        lazySizesConfig.sizesAttr = 'data-sizes';
        lazySizesConfig.lazyClass = 'b-lazyload';
        lazySizesConfig.loadingClass = 'b-lazyload_loading';
        lazySizesConfig.loadedClass = 'b-lazyload_loaded';

        const lazysizes = require('lazysizes');

        document.addEventListener('lazybeforeunveil', (e) => {
            var bg = e.target.getAttribute('data-bg');
            if (bg) {
                e.target.style.backgroundImage = 'url(' + bg + ')';
            }
        });

        lazysizes.init();
        // if (!featureDetect.hasPicture) {
        //     import( /* webpackChunkName: "picturefill" */ 'picturefill').then((loadedModule) => {
        //         loadedModule.default();
        //         lazysizes.init();
        //     });
        // } else {
        //     lazysizes.init();
        // }


    }
}


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/modules/picture-lazy-load.js